import { ZEntityErrorType } from "./ZEntityError";

// eslint-disable-next-line consistent-return
export const entityErrorTypeName = (type: ZEntityErrorType): string => {
  // eslint-disable-next-line default-case
  switch (type) {
    case ZEntityErrorType.attr:
      return "Свойство атрибута";
    case ZEntityErrorType.tech:
      return "Техническая ошибка";
    case ZEntityErrorType.rule:
      return "Бизнес";
  }
};
